import { INIT_PAGE_STATE } from "../../constant/constant";

export const OAUTH_KEY_GET_LIST = "OAUTH_KEY_GET_LIST";
export const OAUTH_KEY_GET_LIST_SUCCESS = "OAUTH_KEY_GET_LIST_SUCCESS";
export const OAUTH_KEY_GET_LIST_ERROR = "OAUTH_KEY_GET_LIST_ERROR";
export const OAUTH_KEY_ADD_EDIT = "OAUTH_KEY_ADD_EDIT";
export const OAUTH_KEY_SAVE_ADD_EDIT = "OAUTH_KEY_SAVE_ADD_EDIT";
export const OAUTH_KEY_SAVE_ADD_EDIT_SUCCESS = "OAUTH_KEY_SAVE_ADD_EDIT_SUCCESS";
export const OAUTH_KEY_SAVE_ADD_EDIT_ERROR = "OAUTH_KEY_SAVE_ADD_EDIT_ERROR";
export const OAUTH_KEY_DELETE = "OAUTH_KEY_DELETE";
export const OAUTH_KEY_DELETE_SUCCESS = "OAUTH_KEY_DELETE_SUCCESS";
export const OAUTH_KEY_DELETE_ERROR = "OAUTH_KEY_DELETE_ERROR";

export const loadOauthKeyList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      limit: INIT_PAGE_STATE.pageSizes[0],
      appName: null,
      dateFrom: null,
      dateTo: null,
    },
    ...p,
  };
  return {
    type: OAUTH_KEY_GET_LIST,
    payload: param,
  };
};

export const loadOauthKeyListSuccess = (data) => ({
  type: OAUTH_KEY_GET_LIST_SUCCESS,
  payload: data,
});

export const loadOauthKeyListError = (error) => ({
  type: OAUTH_KEY_GET_LIST_ERROR,
  payload: error,
});

export const addEditOauthKey = (item, mode = "add") => ({
  type: OAUTH_KEY_ADD_EDIT,
  payload: { item, mode },
});

export const saveAddEditOauthKey = (item, mode = "add", history) => ({
  type: OAUTH_KEY_SAVE_ADD_EDIT,
  payload: { item, mode, history },
});

export const saveAddEditOauthKeySuccess = (data) => ({
  type: OAUTH_KEY_SAVE_ADD_EDIT_SUCCESS,
  payload: data,
});

export const saveAddEditOauthKeyError = (error) => ({
  type: OAUTH_KEY_SAVE_ADD_EDIT_ERROR,
  payload: error,
});

export const deleteOauthKey = (data, confirmed = false) => ({
  type: OAUTH_KEY_DELETE,
  payload: { item: data, confirmed },
});

export const deleteOauthKeySuccess = () => ({
  type: OAUTH_KEY_DELETE_SUCCESS,
});

export const deleteOauthKeyError = (error) => ({
  type: OAUTH_KEY_DELETE_ERROR,
  payload: error,
});
